import * as React from 'react'

const context = React.createContext(null)

export const { Provider } = context

export function useDiscover(props) {
  return React.useContext(context) ?? props
}
